import { useState } from "react"
import { isDesktop, isMobileOnly, isTablet } from "react-device-detect"

const useDeviceType = () => {
  const [isDesktopView] = useState(isTablet || isDesktop)
  const [isMobileView] = useState(isMobileOnly)
  return { isDesktopView, isMobileView }
}

export default useDeviceType
